interface FormSubmitProps {
    label?: string,
}

export function FormSubmit(props: FormSubmitProps) {
    return (
        <input className="bg-primary-400 cursor-pointer p-2 rounded-lg w-full
        hover:bg-primary-600 text-white" type="submit" value={props.label}/>
    )
}